import { BILLING_SOFTWARE_OPTIONS, type ContactFormData } from '@/utils/contact-form.utils';
import { Field, type FieldChangeEvent } from './field';
import { HintField } from './hint-field';

type BillingSoftwareFieldsProps = {
  form: ContactFormData;
  onChange: (event: FieldChangeEvent) => void;
};

export function BillingSoftwareFields({ form, onChange }: BillingSoftwareFieldsProps) {
  let integrationMessage: string | undefined;
  if (form.billingSoftware === 'Autre') {
    integrationMessage =
      'Bonne nouvelle : nous proposons aussi la reprise de données depuis votre logiciel actuel, sans frais. Nous validons simplement la faisabilité avec vous.';
  } else if (form.billingSoftware) {
    integrationMessage = 'Bonne nouvelle : nous proposons la reprise de vos données sans frais !';
  }

  return (
    <div className="relative col-span-2 flex flex-col gap-2">
      <Field
        as="select"
        colSpan={2}
        label="Logiciel de facturation actuel"
        name="billingSoftware"
        value={form.billingSoftware}
        onChange={onChange}
      >
        <option value="">Je n&apos;en ai pas / ne pas renseigner</option>
        {BILLING_SOFTWARE_OPTIONS.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </Field>
      <HintField message={integrationMessage} variant="info" />
    </div>
  );
}
